<script>
  export let style = null, black = false, beige = false, red = false, inline = false
</script>

<svg class:inline class:red class:beige class:black {style} width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <line x1="10.9603" y1="32.9589" x2="32.8806" y2="11.0386" stroke-width="3"/>
  <line x1="32.8803" y1="32.9591" x2="10.9599" y2="11.0388" stroke-width="3"/>
</svg>

<style lang="scss">
  line {
    stroke: $color-mint;
    .black & {
      stroke: black;
    }


    .beige & {
      stroke: $color-beige;
    }

    .red & {
      stroke: $color-red;
    }
  }

  svg.inline {
    height: 1em;
    width: 1em;
  }
</style>